(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusDialogController', CompanySubscriptionStatusDialogController);

    CompanySubscriptionStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanySubscriptionStatus', 'MoneyTransferLog', 'SubscriptionPackage', 'Company', 'CompanyCustom', 'SubscriptionPackageCustom', 'CompanySubscriptionStatusCustom'];

    function CompanySubscriptionStatusDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanySubscriptionStatus, MoneyTransferLog, SubscriptionPackage, Company, CompanyCustom, SubscriptionPackageCustom, CompanySubscriptionStatusCustom) {
        var vm = this;

        vm.companySubscriptionStatus = entity;
        vm.clear = clear;
        vm.save = save;
        // vm.moneytransferlogs = MoneyTransferLog.query();
        vm.subscriptionpackages = [];
        vm.findCompany = findCompany;
        vm.subscriptionPackage_changed = subscriptionPackage_changed;
        vm.onPackageType_changed = onPackageType_changed;
        vm.packageType = "SUBSCRIPTION";
        vm.finalPrice = 0;
        vm.computeFinalPrice = computeFinalPrice;

        loadAll();


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function loadAll() {
            //
            if (vm.companySubscriptionStatus && vm.companySubscriptionStatus.subscriptionPackage && vm.companySubscriptionStatus.subscriptionPackage.packageType)
                vm.packageType = vm.companySubscriptionStatus.subscriptionPackage.packageType;

            getAllSubscriptionPackages();

            if (vm.companySubscriptionStatus.companyInvoiceInfo && vm.companySubscriptionStatus.companyInvoiceInfo.finalPrice)
                vm.finalPrice = vm.companySubscriptionStatus.companyInvoiceInfo.finalPrice;

        }

        function getAllSubscriptionPackages() {

            SubscriptionPackageCustom.getAllActiveSubscriptionPackages(vm.packageType).query().$promise.then(function (result) {
                    vm.subscriptionpackages = result;
                    SubscriptionPackageCustom.getSubscriptionPackageByPTypeAndSType(vm.packageType, "ADMIN").query().$promise.then(
                        function (data) {
                            vm.subscriptionpackages.push(data);
                        })
                }
            );
        }

        function save() {
            vm.isSaving = true;
            if (vm.companySubscriptionStatus.id !== null) {
                CompanySubscriptionStatusCustom.companySubscriptionStatusManual().update(vm.companySubscriptionStatus, onSaveSuccess, onSaveError);
            } else {
                CompanySubscriptionStatusCustom.companySubscriptionStatusManual().save(vm.companySubscriptionStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companySubscriptionStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function findCompany() {

            if (vm.companyKeyUrl) {
                CompanyCustom.findCompanyByKeyURL(vm.companyKeyUrl).query().$promise.then(function (result) {

                    if (result) {
                        vm.companySubscriptionStatus.company = result;
                    }
                })
            }

        }

        function subscriptionPackage_changed() {

            if (!vm.companySubscriptionStatus.subscriptionPackage.id)
                return;

            var packageItem = null;

            angular.forEach(vm.subscriptionpackages, function (item) {
                if (item.id == vm.companySubscriptionStatus.subscriptionPackage.id)
                    packageItem = item;
            });

            if (!packageItem)
                return;

            if (!vm.companySubscriptionStatus.companyInvoiceInfo)
                vm.companySubscriptionStatus.companyInvoiceInfo = {};
            if (packageItem.chargeFee) {
                vm.companySubscriptionStatus.companyInvoiceInfo.subscriptionPrice = packageItem.chargeFee;
            }
            computeFinalPrice();
        }

        function onPackageType_changed() {
            getAllSubscriptionPackages();
        }

        function computeFinalPrice() {

            if (!vm.companySubscriptionStatus.companyInvoiceInfo.subscriptionPrice)
                return;

            var price = vm.companySubscriptionStatus.companyInvoiceInfo.subscriptionPrice;
            var discount = vm.companySubscriptionStatus.companyInvoiceInfo.discount ? vm.companySubscriptionStatus.companyInvoiceInfo.discount : 0;
            var vat = (price - discount) * 10 / 100;
            vm.companySubscriptionStatus.companyInvoiceInfo.vat = vat;

            vm.finalPrice = price - discount + vat;
        }
    }
})();
